





















































import { Vue, Component, Watch }   from 'vue-property-decorator'
import { FontAwesomeIcon }  from '@fortawesome/vue-fontawesome'
import ListeNotes from '@/views/Deliberation/ListeNotes.vue'
import Statistiques from '@/views/Deliberation/Statistiques.vue'
import EcartMoyenneCorrecteur from '@/views/Deliberation/EcartMoyenneCorrecteur.vue'
import Normalisation from '@/views/Deliberation/Normalisation.vue'
import Harmonisation from '@/views/Deliberation/Harmonisation.vue'
import Arrondi from '@/views/Deliberation/Arrondi.vue'
import Back from '@/components/Tools/Back.vue'
import { mapGetters, mapState } from 'vuex'
/**
 * Composant principal de la gestion des candidats
*/
@Component({
    computed: {
        ...mapGetters('auth', ['authUser', 'can', 'cannot', 'isA', 'isNotA', 'user_session_id']),
        ...mapGetters('epreuveCorrectionResultat', ['epreuveCorrectionResultatSelect', 'tableAjustementParams']),
        ...mapState('auth', ['user', 'authUser', 'user_session_id'])
    },
    components: {
        'font-awesome-icon': FontAwesomeIcon,
        ListeNotes,
        Statistiques,
        EcartMoyenneCorrecteur,
        Normalisation,
        Harmonisation,
        Arrondi,
        Back
    }
})
export default class EpreuveCorrectionCandidats extends Vue
{
    epreuvecorrectionId: any = '0'
    tabSelected = 'listenote'
    chargement = false
    libelleBack = ''
    EcartMoyenneCorrecteur = EcartMoyenneCorrecteur
    Normalisation = Normalisation
    Harmonisation = Harmonisation
    Arrondi = Arrondi

    @Watch('user_session_id')
    refreshInterface () {
        this.$router.push({ path: '/liste_epreuve_correction_resultats' })
    }

    getDynamicTabLabel (ajustement: string) {
        switch (ajustement) {
            case 'ecart_moyenne_correcteur':
                return 'PAR CORRECTEUR'
            case 'normalisation':
                return 'NORMALISATION'
            case 'harmonisation':
                return 'HARMONISATION'
            case 'arrondi':
                return 'ARRONDI'
            default:
                return 'PAR CORRECTEUR'
        }
    }

    getDynamicComponent(ajustement: string) {
        switch (ajustement) {
            case 'ecart_moyenne_correcteur':
                return EcartMoyenneCorrecteur
            case 'normalisation':
                return  Normalisation
            case 'harmonisation':
                return Harmonisation
            case 'arrondi':
                return Arrondi
            default:
                return EcartMoyenneCorrecteur
        }
    }

    mounted () {
        this.chargement = true
        this.epreuvecorrectionId = this.$route.params.epreuve_correction_id ? this.$route.params.epreuve_correction_id : 0
        this.$store.state.epreuveCorrectionResultat.epreuveCorrectionResultatSelect = null
        this.$store.dispatch('epreuveCorrectionResultat/getEpreuveCorrectionResultat', { epreuveCorrectionResultat_id: this.epreuvecorrectionId }).then(() => {
            const epcr = this.$store.state.epreuveCorrectionResultat.epreuveCorrectionResultatSelect
            const phaseLibelle = epcr.epreuve_correction && epcr.epreuve_correction.phase && epcr.epreuve_correction.phase.name ? epcr.epreuve_correction.phase.name : '-'
            let filiere = ''
            if (epcr.epreuve_correction && epcr.epreuve_correction.concours) {
                for (const concourkey in epcr.epreuve_correction.concours) {
                    const concourTemp = epcr.epreuve_correction.concours[concourkey]
                    if (concourTemp) {
                        if (filiere.length > 0 && concourTemp) {
                            filiere += ', '
                        }
                        filiere += concourTemp ? concourTemp.name : ''
                    }
                }
            }
            this.libelleBack = phaseLibelle + ' - ' + filiere + ' - ' + (epcr.epreuve_correction && epcr.epreuve_correction.name ? epcr.epreuve_correction.name : '')
            this.chargement = false
        })
    }
}
